import { type GroupCapFields, MAX_METRIC_GROUPS } from "./MetricRecord";

/** What the reader is told about groups the server's cap left out. */
export interface GroupTruncation {
  /** Distinct non-null groups in the window, or `null` when the server gave
   *  no count. */
  totalGroups: number | null;
  /** Groups beyond {@link MAX_METRIC_GROUPS} that were not returned, or `null`
   *  when the server gave no count. */
  hiddenGroups: number | null;
}

/**
 * The group truncation a grouped response reports, or `null` when every group
 * came back — including every response from a server that predates the cap.
 * `groups_truncated` decides; the total only sizes the message.
 */
export function groupTruncationOf(
  response: GroupCapFields | undefined,
): GroupTruncation | null {
  if (response?.groups_truncated !== true) {
    return null;
  }
  const totalGroups =
    typeof response.total_groups === "number" ? response.total_groups : null;
  return {
    totalGroups,
    hiddenGroups:
      totalGroups === null
        ? null
        : Math.max(totalGroups - MAX_METRIC_GROUPS, 0),
  };
}
